<div *ngIf="attendanceDate">
  <app-unbooked-sessions [attendanceDate]="attendanceDate"></app-unbooked-sessions>
</div>
<div *ngIf="attendanceDate">
  <app-booked-sessions [attendanceDate]="attendanceDate"></app-booked-sessions>
</div>
